
import {
  CREATING_WAREHOUSE,
  CREATE_WAREHOUSE_ERROR,
  CREATED_WAREHOUSE,
  REQUESTING_WAREHOUSES,
  REQUEST_WAREHOUSES_ERROR,
  RECEIVE_WAREHOUSES,
  REQUEST_WAREHOUSE_BY_ID,
  REQUEST_WAREHOUSE_BY_ID_ERROR,
  RECEIVE_WAREHOUSE_BY_ID,
  UPDATED_WAREHOUSE_SETTINGS
} from 'actions'

const initialState = {}

const initialWorkspaceState = {
  isCreating: false,
  didCreateFail: false,
  isRequesting: false,
  didRequestFail: false,
  hasRequested: false,
  data: {}
}

const initialWarehouseState = {
  isRequesting: false,
  didRequestFail: false,
  didInvalidate: false,
  data: {}
}

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case CREATING_WAREHOUSE:
      return {
        ...state,
        [payload.workspaceSlug]: {
          ...initialWorkspaceState,
          ...state[payload.workspaceSlug],
          isCreating: true
        }
      }
    case CREATE_WAREHOUSE_ERROR:
      return {
        ...state,
        [payload.workspaceSlug]: {
          ...initialWorkspaceState,
          ...state[payload.workspaceSlug],
          isCreating: false,
          didCreateFail: true
        }
      }
    case CREATED_WAREHOUSE:
      return {
        ...state,
        [payload.workspaceSlug]: {
          ...initialWorkspaceState,
          ...state[payload.workspaceSlug],
          isCreating: false,
          didCreateFail: false,
          data: {
            [payload.data.id]: {
              ...initialWarehouseState,
              data: payload.data
            }
          }
        }
      }
    case REQUESTING_WAREHOUSES:
      return {
        ...state,
        [payload.workspaceSlug]: {
          ...initialWorkspaceState,
          ...state[payload.workspaceSlug],
          isRequesting: true,
          didRequestFail: false,
          data: {}
        }
      }
    case REQUEST_WAREHOUSES_ERROR:
      return {
        ...state,
        [payload.workspaceSlug]: {
          ...initialWorkspaceState,
          ...state[payload.workspaceSlug],
          isRequesting: false,
          didRequestFail: true,
          data: {}
        }
      }
    case RECEIVE_WAREHOUSES:
      return {
        ...state,
        [payload.workspaceSlug]: {
          ...initialWorkspaceState,
          ...state[payload.workspaceSlug],
          isRequesting: false,
          didRequestFail: false,
          hasRequested: true,
          data: toIDMap(payload.response)
        }
      }
    case REQUEST_WAREHOUSE_BY_ID:
    case REQUEST_WAREHOUSE_BY_ID_ERROR:
    case RECEIVE_WAREHOUSE_BY_ID:
    case UPDATED_WAREHOUSE_SETTINGS:
      return {
        ...state,
        [payload.workspaceSlug]: {
          ...initialWorkspaceState,
          ...state[payload.workspaceSlug],
          data: {
            ...(state[payload.workspaceSlug] || {}).data,
            [payload.warehouseId]: warehouse({ type, payload })
          }
        }
      }
    default:
      return state
  }
}

function warehouse ({ type, payload }) {
  switch (type) {
    case REQUEST_WAREHOUSE_BY_ID:
      return {
        ...initialWarehouseState,
        isRequesting: true
      }
    case RECEIVE_WAREHOUSE_BY_ID:
      return {
        ...initialWarehouseState,
        isRequesting: false,
        data: payload.response
      }
    case REQUEST_WAREHOUSE_BY_ID_ERROR:
      return {
        ...initialWarehouseState,
        isRequesting: false,
        didRequestFail: true
      }
    case UPDATED_WAREHOUSE_SETTINGS:
      return {
        ...initialWarehouseState,
        data: payload.response
      }
    default:
    // meh
  }
}

/**
 * Map `array` by each item's id.
 */

function toIDMap (arr) {
  const map = {}
  for (let i = 0; i < arr.length; i++) {
    map[arr[i].id] = {
      ...initialWarehouseState,
      data: arr[i]
    }
  }
  return map
}



// WEBPACK FOOTER //
// ./reducers/warehouses.js